import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
/**
 * 格式化为utc展示时间
 *
 * @param {number|string} time 时间戳
 * @param {string} format 格式化方式
 * @return {string} utc时间展示
 */
export function formatUTCTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
    return `${dayjs.utc(Number(time)).format(format)}`;
}

/**
 *
 * 格式化为本地展示时间
 *
 * @param {number|string} time 时间戳
 * @param {string} format 格式化方式
 * @return {string} 本地时间展示
 */
export function formatLocalTime(time, format = 'YYYY-MM-DD HH:mm:ss') {
    return `${dayjs.utc(Number(time)).local().format(format)}`;
}

export function timestamp() {
    return dayjs().valueOf();
}

/**
 *
 * 前补0
 *
 * @param {number|string} num 需要补0的数字
 * @param {number} n 总位数，不够在前面补0
 * @return {string} 补0后的字符串
 */
const prefixZero = (num, n) => (Array(n).join(0) + num).slice(-n);

/**
 *
 * 时间戳转单位时间
 *
 * @param {number|string} ms 时间戳
 * @return {string} 日、时、分、秒、毫秒、特殊小时（最大值99）
 */
export const msToRemainTime = (ms) => {
    if (!(typeof ms === 'number' && !Number.isNaN(ms))) {
        return {
            day: '00',
            hour: '00',
            min: '00',
            sec: '00',
            million: '000',
            extraHour: '00',
        };
    }
    const internalMS = Math.max(0, ms);
    const msPerSecond = 1000;
    const msPerMinute = msPerSecond * 60;
    const msPerHour = msPerMinute * 60;
    const msPerDay = msPerHour * 24;

    const day = Math.floor(internalMS / msPerDay);
    const hour = prefixZero(Math.floor((internalMS % msPerDay) / msPerHour), 2);
    const min = prefixZero(Math.floor(((internalMS % msPerDay) % msPerHour) / msPerMinute), 2);
    const sec = prefixZero(Math.floor((((internalMS % msPerDay) % msPerHour) % msPerMinute) / msPerSecond), 2);
    const million = prefixZero(internalMS % msPerSecond, 3);

    const extraHour = prefixZero(Math.min((day * 24) + parseInt(hour, 10), 99), 2);
    const doubleDigitDay = prefixZero(day, 2);

    return {
        day,
        hour,
        min,
        sec,
        million,
        extraHour,
        doubleDigitDay,
    };
};

/**
 * 05.24 16:37 => 05.24 17:00
 * 05.24 17:00 => 05.24 18:00
 * 05.24 23:45 => 05.24 24:00
 *
 * @param {*} timestamp 时间戳
 * @return {string} 如 05.24 24:00
 */
// eslint-disable-next-line
export const getNextClockTime = (timestamp) => {
    const utcTime = dayjs.utc(timestamp);
    const Md = utcTime.format('YYYY-MM-DD');
    const currentHour = utcTime.hour();
    let nextClock = Number(currentHour) < 24 ? currentHour + 1 : currentHour;
    nextClock = `${nextClock}`.length < 2 ? `0${nextClock}` : nextClock;
    return `${Md} ${nextClock}:00`;
};
/**
 * 判断time 在今天24点前发生，且在x 天以内
 *
 * @param {number | string | Date} time  时间
 * @param {number} xDays 多少天内
 * @return {boolean}
 */
export function happenInDays(time, xDays) {
    const onlineObj = dayjs(Number(time));
    const nowObj = dayjs();
    const endOfToday = dayjs(nowObj.format('YYYY-MM-DD 23:59:59'));
    const endOfXDayObj = dayjs(
        onlineObj.add(xDays, 'days').format('YYYY-MM-DD 23:59:59'),
    );
    return onlineObj.isBefore(endOfToday) && endOfXDayObj.isAfter(nowObj);
}
